import EditableField from "../common/EditableField";

function EditableGuestDetailItem({
  label,
  name,
  type,
  value,
  onChange,
  isEditing,
  className,
  options,
}) {
  return (
    <div className={className}>
      <p className={`text-sm text-gray-500 ${isEditing && "mb-1"}`}>{label}</p>
      <EditableField
        name={name}
        type={type || "string"}
        value={value || ""}
        onSave={(e) => {
          onChange(e);
        }}
        isEditing={isEditing}
        options={options}
      />
    </div>
  );
}

export default EditableGuestDetailItem;
